import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom"; // 'Navigate'をインポート
import "./scss/common.scss";
import LoginPage from "./pages/LoginPage";
import TradePage from "./pages/TradePage";
import TestPage from "./pages/TestPage";
import AnalyticsPage from "./pages/AnalyticsPage";
import { useAuth } from "./contexts/AuthContext";

function App() {
  const { isLoggedIn } = useAuth();

  const renderPage = () => {
    if (!isLoggedIn) {
      return <Navigate to="/login" replace />;
    }
    return (
      <Routes>
        <Route path="/" element={<TradePage />} />
        <Route path="/trade" element={<TradePage />} />
        <Route path="/test" element={<TestPage />} />
      </Routes>
    );
  };

  return (
    <Router>
      <div className="App">
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="*" element={renderPage()} />
          <Route path="/analytics" element={<AnalyticsPage />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
